import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { beforeAfter } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-29" data-mp="3ogauho56wx49">
      <div className="mx-auto w-full max-w-2xl" data-id="element-30" data-mp="3ohu9zcj0v44z">
        <h2 className="text-center font-display text-[1.65rem] font-bold leading-tight text-navy sm:text-4xl" data-id="element-31" data-mp="3sglaltmp53wu">
          Antes y con Ruta Clínica de Menopausia™
        </h2>

        <div className="mt-8 space-y-4" data-id="element-32" data-mp="3jgeq3nskz3o6">
          {beforeAfter.map(row => <div key={row.before} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-33" data-mp="3jihrf3z6oj87">
              <div className="flex items-start gap-3 border-b border-navy/10 bg-navy/[0.04] px-4 py-3.5" data-id="element-34" data-mp="39rwsfffllcor">
                <XCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-35" data-mp="2vsf0wsax3lbp" />
                <div data-id="element-36" data-mp="30ovo9kaalvnq">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-navy/40" data-id="element-37" data-mp="30pdqcxjmz43k">
                    ❌ Antes
                  </p>
                  <p className="mt-0.5 text-sm leading-snug text-navy/70 sm:text-base" data-id="element-38" data-mp="t3i2yf2f7e2q">
                    {row.before}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 bg-white px-4 py-3.5" data-id="element-39" data-mp="123n6ge4htsbm">
                <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-40" data-mp="121k733hgamu8" />
                <div data-id="element-41" data-mp="9g0uahh79fd5">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-42" data-mp="9gsr1vmj9j50">
                    ✅ Con la Ruta Clínica
                  </p>
                  <p className="mt-0.5 text-sm font-medium leading-snug text-navy sm:text-base" data-id="element-43" data-mp="jcvs0y5nfbqd">
                    {row.after}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-9" data-id="element-44" data-mp="3mtcm2td0ti5d">
          <CTAButton label="Quiero trabajar así desde hoy" note="Pago único de USD $13.99" data-id="element-45" data-mp="3ms1gqp3xg2c5" />
        </div>
      </div>
    </section>;
}